// Ubicación en el repo: src/components/PasswordField.jsx
// Input de contraseña con botón para mostrar/ocultar el texto (el "ojo").
// Se usa en los 3 lugares donde se escribe una contraseña (Login.jsx,
// SetPassword.jsx x2) para no repetir la misma lógica de toggle en cada uno.
// El botón queda fuera del tab order (tabIndex=-1) para no interrumpir el
// flujo normal de Tab entre campos del formulario.
import { useState } from 'react';

export default function PasswordField({
  value,
  onChange,
  autoComplete,
  autoFocus,
  required,
  placeholder,
}) {
  const [visible, setVisible] = useState(false);

  return (
    <div className="password-field-wrap">
      <input
        type={visible ? 'text' : 'password'}
        value={value}
        onChange={onChange}
        autoComplete={autoComplete}
        autoFocus={autoFocus}
        required={required}
        placeholder={placeholder}
        style={{ paddingRight: 40 }}
      />
      <button
        type="button"
        className="password-toggle-btn"
        onClick={() => setVisible((v) => !v)}
        tabIndex={-1}
        aria-label={visible ? 'Ocultar contraseña' : 'Mostrar contraseña'}
        title={visible ? 'Ocultar contraseña' : 'Mostrar contraseña'}
      >
        {visible ? '🙈' : '👁️'}
      </button>
    </div>
  );
}
